module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsPassportSnils-ad5f51817a1bd078ef14c5e4cc9c84d8.png";